import { storyblokEditable } from "@storyblok/react";
import ListItem from "./ListItem";

const BrandsHeader = ({ blok }) => (
  <div className="wrap">
    <div
      className="brandsheader-wrap inner-wrap flex items-center"
      {...storyblokEditable(blok)}
    >
      <div className="brandsheader-wrap-content flex">
        <div className="brandsheader-left">
          {/*     <img src={blok.logo.filename} alt={blok.logo.alt} /> */}
          <div className="brandsheader-img-box">
          <img
              className="brandsheader-logo hide-mobile"
              src={blok.logo.filename}
              alt={blok.logo.alt}
            />
             <img
            className="brandsheader-logo hide-desktop"
            src={blok.logo.filename}
            alt={blok.logo.alt}
          />
          </div>
          <h2 className="brandsheader-branding text-2xl">{blok.slogan}</h2>
          <div>
         

            <img
              className="brandsheader-mobileimg hide-mobile"
              src={blok.image.filename}
              alt={blok.image.alt}
            />
          </div>
         {blok.infotext && (<p className="brandsheader-infotext pb-3">{blok.infotext}</p>)} 
         {blok.infotext2 && (<p className="brandsheader-infotext pb-3">{blok.infotext2}</p>)} 
         {blok.infotext3 && (<p className="brandsheader-infotext pb-3">{blok.infotext3}</p>)} 
         {blok.infotext4 && (<p className="brandsheader-infotext pb-3">{blok.infotext4}</p>)} 
         {blok.infotext5 && (<p className="brandsheader-infotext">{blok.infotext5}</p>)} 

          <ul className="brandsheader-list">
            <ListItem blok={blok} />
          </ul>
        </div>
        <div className="brandsheader-right ml-16">
         

          <img
            className="hide-desktop"
            src={blok.image.filename}
            alt={blok.image.alt}
          />
        </div>
      </div>
    </div>
  </div>
);
export default BrandsHeader;
